import React from "react"
import md5 from "js-md5";
import 'whatwg-fetch'
import BScroll from 'better-scroll';
import {Modal, Popover} from "antd";
import "../cmpts/overdueTips/style/index.less"
import {URL_CORP_APP_AGENT_CONFIG, URL_DISTRI_GOODS_UPLOAD, ZKY_URL_DISTRI_GOODS_UPLOAD} from "./variables";
import {FetchUtil} from "./fetch_util";
import Message from "../cmpts/ant/Message";


const confirm = Modal.confirm
let expireData = [];
const corpid = "",
    provider_secret = ""


export function checkPhoneNo(phoneNo) {
    var phoneNoReg = /^1[3456789]\d{9}$/;
    if (!phoneNoReg.test(phoneNo)) {
        return false;
    }
    return true;
}

export function regIdCard(data) {
    let reg = /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/
    if (!reg.test(data)) {
        return false
    } else {
        return true
    }
}

// 验证手机号和座机号
export function checkMobile(phoneNo) {
    var phoneNoReg = /^[\d-]+$/;
    if (!phoneNoReg.test(phoneNo)) {
        return false;
    }
    return true;
}

export function checkEmail(email) {
    var emailReg = /^(\w)+(\.\w+)*@(\w)+((\.\w{2,6}){1,3})$/;
    if (!emailReg.test(email)) {
        return false;
    }
    return true;
}


//检查验证码是否合法
export function checkSmsCode(code) {
    var codeReg = /^\d{6}$/;
    if (!codeReg.test(code)) {
        return false;
    }
    return true;
}

export function checkPassword(pwd) {
    var pwdReg = /^(?![^a-zA-Z]+$)(?!\D+$).{8,}$/;
    if (!pwdReg.test(pwd)) {
        return false;
    }
    return true;
}

export function checkUrl(url) {
    var urlReg = /^((https?|ftp)?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
    // var urlReg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/|www\.)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/gi;
    if (!urlReg.test(url)) {
        return false;
    }
    return true
}

export function changeUrlArg(url, arg, arg_val) {
    var pattern = arg + '=([^&]*)';
    var replaceText = arg + '=' + arg_val;
    if (url.match(pattern)) {
        var tmp = '/(' + arg + '=)([^&]*)/gi';
        tmp = url.replace(eval(tmp), replaceText);
        return tmp;
    } else {
        if (url.match('[\?]')) {
            return url + '&' + replaceText;
        } else {
            return url + '?' + replaceText;
        }
    }
}

export function getUrlArg(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");

    var r = window.location.search.substr(1).match(reg);

    if (r != null) return decodeURIComponent(r[2]);
    return null;
}

var oldFetchfn = fetch; //拦截原始的fetch方法
export function fetchTimeout(input, opts) {//定义新的fetch方法，封装原有的fetch方法
    var fetchPromise = oldFetchfn(input, opts);
    var timeoutPromise = new Promise(function (resolve, reject) {
        setTimeout(() => {
            reject(new Error("fetch timeout"))
        }, opts.timeout)
    });
    return Promise.race([fetchPromise, timeoutPromise])
}


class Util {
    // 直接裁剪到需要的字数
    static limitVal(str, limit) {
        var w = 0;
        if (str != '' && str != null) {
            for (var i = 0; i < str.length; i++) {
                var c = str.charCodeAt(i);
                if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
                    w++;
                } else {
                    w += 3;
                }
                if (w > limit) {
                    str = str.substr(0, i);
                    break;
                }
            }
        }
        return str;
    }

    // 得到汉字和字母的总数
    static getStringLen(val) {
        var len = 0;
        for (var i = 0; i < val.length; i++) {
            var a = val.charAt(i);
            if (a.match(/[^\x00-\xff]/ig) != null) {
                len += 2;
            } else {
                len += 1;
            }
        }
        return len;
    }

    /*
      * @params
      * 分销奖励最大比例
      * */
    static DistriMaxRate() {
        return 99;
    }

    /*
    * @params
    * 分销奖励最低奖励金额（分）*/
    static DistriMinPrice() {
        return 30;
    }


    // 直接裁剪到需要的字数
    static limitValWx(val, limit) {
        var w = 0;
        if (val != '' && val != null) {
            var len = 0, flag = false
            for (var i = 0; i < val.length; i++) {
                let reg = /^[\u4e00-\u9fa5]+$/
                let regx = /^[a-zA-Z0-9]+$/
                if (reg.test(val[i])) {
                    len += 3;
                } else if (regx.test(val[i])) {
                    len++
                } else {
                    flag = true
                }
                if (len > limit) {
                    val = val.substr(0, i);
                    break;
                } else if (flag = true && (len + 3 > limit)) {
                    val = val.substr(0, i);
                    break;
                }
            }

            // console.log(len)
            // for (var i = 0; i < str.length; i++) {
            //     var c = str.charCodeAt(i);
            //     if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
            //         w++;
            //     } else {
            //         w += 3;
            //     }
            //
            // }
        }
        return val;
    }

    // 得到汉字和字母的总数
    static getStringLenWx(val) {
        var len = 0, flag = false
        for (var i = 0; i < val.length; i++) {
            let reg = /^[\u4e00-\u9fa5]+$/
            let regx = /^[a-zA-Z0-9]+$/
            if (reg.test(val[i])) {
                len += 3;
            } else if (regx.test(val[i])) {
                len++
            } else {
                flag = true
            }
        }
        if (flag) {
            len += 3
        }

        return len;
    }


    static orderNumChange(num) {
        let str = num.toString(), unit = ""
        if (str.length >= 5 && str.length < 9) {
            str = parseFloat(num / 10000).toFixed(1)
            unit = "万"
        } else if (str.length >= 9) {
            str = parseFloat(num / 100000000).toFixed(1)
            unit = "亿"
        }
        return {
            str: str,
            unit: unit
        }
    }

    // 分，单位换算
    static centChange(num) {
        num = Number(num);
        if (isNaN(num) || num < 0) {
            num = 0;
        }
        let str = num.toString(), unit = "元";
        if (str.length >= 7 && str.length < 11) {
            str = parseFloat(num / 1000000).toFixed(2);
            unit = "万"
        } else if (str.length >= 11) {
            str = parseFloat(num / 10000000000).toFixed(2);
            unit = "亿"
        } else {
            str = parseFloat(num / 100).toFixed(2);
        }
        return {
            str: str,
            unit: unit
        }
    }

    // 分，换算成元
    static centTransformOut(num) {
        num = parseFloat(num) / 100;
        let price = 0;
        if (isNaN(num)) {
            price = 0.00;
        } else {
            price = num;
        }

        price = price.toFixed(2);

        return price;
    }

    // 分换算成元，保留负数
    static centTransformOutMin(num) {
        num = parseFloat(num) / 100;
        let price = 0;
        if (isNaN(num)) {
            price = 0.00;
        } else {
            price = num;
        }

        price = price.toFixed(2);

        return price;
    }

    // 月转换成年
    static monthTransformOut(month) {
        let year = Number(month) / 12;
        return year;
    }


    static inputWordLimit(limit, e) {
        var v = e.target.value;
        if (v.length > limit) {
            e.target.value = v.substring(0, limit);
            $(e.target).siblings('.wordlimit').html(limit + "/" + limit)
        } else {
            $(e.target).siblings('.wordlimit').html(v.length + "/" + limit)
        }
    }

    static setIsSaveing(flag) {
        if (flag) {
            $("#saveBtn").html("保存中...");
            $("#saveBtn").attr("disabled", "true");
        } else {
            $("#saveBtn").html("保存");
            $("#saveBtn").removeAttr("disabled");
        }
    }

    static disabledBtn(select, disabled, text, disabledText) {
        if (disabled) {
            if (disabledText) {
                $(select).html(disabledText);
            }
            $(select).attr("disabled", "true");
        } else {
            if (text) {
                $(select).html(text);
            }
            $(select).removeAttr("disabled");
        }
    }

    static setIsSaveing(btnSelect, flag) {
        if (flag) {
            $(btnSelect).html("保存中...");
            $(btnSelect).attr("disabled", "true");
        } else {
            $(btnSelect).html("保存");
            $(btnSelect).removeAttr("disabled");
        }
    }

    static isNull(val) {
        if (val == null || typeof val == 'undefined') {
            return true;
        }
        return false;
    }

    static isEmpty(val) {
        // val = val.trim();
        if (val == null || String(val) == '' || typeof val == 'undefined') {
            return true;
        }
        return false;
    }

    static transformEndTime(endtime) {
        var offset = endtime - new Date().getTime();
        if (offset > 0) {
            var days = Math.floor(offset / (24 * 60 * 60 * 1000));
            if (days > 0) {
                return days + '天';
            }
            var hours = Math.floor(offset / (60 * 60 * 1000));
            if (hours > 0) {
                return hours + '小时';
            }
            var minutes = Math.floor(offset / (60 * 1000));
            if (minutes > 0) {
                return minutes + '分钟';
            }
        }
    }

    static transformStartedTime(starttime) {
        var offset = new Date().getTime() - starttime;
        if (offset > 0) {
            var days = Math.floor(offset / (24 * 60 * 60 * 1000));
            if (days > 0) {
                return days + '天';
            }
            var hours = Math.floor(offset / (60 * 60 * 1000));
            if (hours > 0) {
                return hours + '小时';
            }
            var minutes = Math.floor(offset / (60 * 1000));
            if (minutes > 0) {
                return minutes + '分钟';
            }
        }
    }

    static initScroll(ref) {
        const options = {
            scrollY: true,
            // disableMouse: false,
            // disableTouch: true,
            mouseWheel: {
                speed: 20,
                invert: false,
                easeTime: 300
            },
            scrollbar: {
                fade: false,
                interactive: true // 1.8.0 新增
            },
            tap: true,
            preventDefault: false,
            preventDefaultException: {
                tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|DIV|UL|LI|P|SPAN|TABLE)$/,
                className: /(^|\s)editable(\s|$)/,
            }
        };
        return new BScroll(ref, options);
    }

    static initCollapse() {
        $('.mxd-collapse-trigger').click(function () {
            var target = $(this).attr('data-target');
            if (!$(target).hasClass('mxd-collapse')) {
                $(target).addClass('mxd-collapse');
                $(target).hide(100);
            } else {
                $(target).removeClass('mxd-collapse');
                $(target).show(100);
            }
        })
    }

    static wordLimit(limit, e) {
        var v = e.target.value;
        $(e.target).siblings('.word-limit').html(v.length + "/" + limit)
    }

    static initDatetimepicker(select, changeDate, option) {
        if (option) {
            $(select).datetimepicker(option).on('hide', function () {
                $(this).blur();
            }).on('changeDate', function () {
                if (changeDate) {
                    changeDate()
                }
            });
        } else {
            $(select).datetimepicker({
                format: 'yyyy-mm-dd hh:ii',
                language: "zh-CN",
                todayHighlight: true,
                autoclose: true
            }).on('hide', function () {
                $(this).blur();
            }).on('changeDate', function () {
                if (changeDate) {
                    changeDate()
                }
            });
        }
    }

    static getPreDate(date) {
        var now = new Date();
        var day = 24 * 60 * 60 * 1000;
        var dateb = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
        var date0 = dateb + day;
        var date1 = date0 + day;
        var date2 = date1 + day;
        var datetime = date.getTime();
        var msg = '';
        if (datetime > dateb && datetime < date2) {
            var time = date.format('hh点mm分');
            if (datetime < date0) {
                msg = '今天' + time
            } else if (datetime < date1) {
                msg = '明天' + time
            } else if (datetime < date2) {
                msg = '后天' + time
            }
        } else {
            msg = date.format('yyyy-MM-dd hh:mm')
        }
        return msg;
    }

    static getDateLite(datetime) {
        var date = new Date(datetime);
        var now = new Date();
        var day = 24 * 60 * 60 * 1000;
        var dd = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
        var date0 = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime() + day;
        var date1 = date0 + day;
        var date2 = date1 + day;
        var msg = '';
        if (datetime >= dd && datetime < date2) {
            var time = date.format('hh点mm分');
            if (datetime < date0) {
                msg = '今天' + time
            } else if (datetime < date1) {
                msg = '明天' + time
            } else if (datetime < date2) {
                msg = '后天' + time
            }
        } else {
            msg = date.format('yyyy-MM-dd hh:mm')
        }
        return msg;
    }

    // 时分秒转化成秒
    static transfromOutSecond(datetime) {
        var date = null, hour = null, minute = null, second = null;
        if (datetime) {
            date = new Date(datetime);
            hour = date.getHours();
            minute = date.getMinutes();
            second = date.getSeconds();
            second += hour * 60 * 60;
            second += minute * 60;
        }

        return second

    }

    //秒转化成时分秒
    static transfromInSecond(datetime) {
        var date = null, hour = null, minute = null, second = null, str = null;
        hour = parseInt(datetime / (60 * 60));
        minute = parseInt((datetime - hour * 60 * 60) / 60);
        second = datetime - hour * 60 * 60 - minute * 60;
        if (String(hour).length < 2) {
            hour = '0' + hour;
        }
        if (String(minute).length < 2) {
            minute = '0' + minute;
        }
        if (String(second).length < 2) {
            second = '0' + second;
        }
        str = hour + ':' + minute + ':' + second;
        return str;
    }

    static coverEmail(email) {
        if (email) {
            return email.substring(0, 3) + "******" + email.substring(email.indexOf('@') - 1);
        }
    }

    static showProductExpiredModal(msg) {

    }


    static checkDateTime(time) {
        var reg = /^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}$/;
        if (!reg.test(time)) {
            return false;
        }
        return true;
    }

    static getEmailLink(mail) {
        var arr = mail.split('@');
        if (arr.length > 1) {
            var $t = arr[1];
            $t = $t.toLowerCase();
            if ($t == '163.com') {
                return 'mail.163.com';
            } else if ($t == 'vip.163.com') {
                return 'vip.163.com';
            } else if ($t == '126.com') {
                return 'mail.126.com';
            } else if ($t == 'qq.com' || $t == 'vip.qq.com' || $t == 'foxmail.com') {
                return 'mail.qq.com';
            } else if ($t == 'gmail.com') {
                return 'mail.google.com';
            } else if ($t == 'sohu.com') {
                return 'mail.sohu.com';
            } else if ($t == 'tom.com') {
                return 'mail.tom.com';
            } else if ($t == 'vip.sina.com') {
                return 'vip.sina.com';
            } else if ($t == 'sina.com.cn' || $t == 'sina.com') {
                return 'mail.sina.com.cn';
            } else if ($t == 'tom.com') {
                return 'mail.tom.com';
            } else if ($t == 'yahoo.com.cn' || $t == 'yahoo.cn') {
                return 'mail.cn.yahoo.com';
            } else if ($t == 'tom.com') {
                return 'mail.tom.com';
            } else if ($t == 'yeah.net') {
                return 'www.yeah.net';
            } else if ($t == '21cn.com') {
                return 'mail.21cn.com';
            } else if ($t == 'hotmail.com') {
                return 'www.hotmail.com';
            } else if ($t == 'sogou.com') {
                return 'mail.sogou.com';
            } else if ($t == '188.com') {
                return 'www.188.com';
            } else if ($t == '139.com') {
                return 'mail.10086.cn';
            } else if ($t == '189.cn') {
                return 'webmail15.189.cn/webmail';
            } else if ($t == 'wo.com.cn') {
                return 'mail.wo.com.cn/smsmail';
            } else if ($t == '139.com') {
                return 'mail.10086.cn';
            }
        }
        return '';
    };

    static disableScroll() {
        // window.contentScroll.disable();
    }

    static enableScroll() {
        // window.contentScroll.enable();
    }

    static refreshScroll() {
        // window.contentScroll.refresh();

    }

    static toTopScroll() {
        // window.contentScroll.scrollTo(0, 0)
    }

    static getCorpId() {
        return corpid
    }

    static getProviderToken() {
        let fetchUtil = new FetchUtil()
        fetchUtil.init()
            .setUrl("https://qyapi.weixin.qq.com/cgi-bin/service/get_provider_token")
            .setMethod("POST")
            .setCookieCors()
            .setBody({
                corpid: corpid,
                provider_secret: provider_secret
            })
            .setBodyType('json')
            .dofetch()
            .then((msg) => {
                let providerAccessToken = msg.provider_access_token
                return providerAccessToken
            })
            .catch((error) => {
                console.log(error)
            })
    }

    static initCorpWx(corpid) {

        let url = encodeURIComponent(window.location.href);
        // let url = encodeURIComponent('http://test.94mxd.com/index/corp/member/list');
        let fetchUtil = new FetchUtil()
        fetchUtil.init()
            .setUrl(URL_CORP_APP_AGENT_CONFIG + "?corpId=" + corpid + "&url=" + url)
            .setMethod("GET")
            .setCookieCors()
            .setBodyType('json')
            .dofetch()
            .then((msg) => {
                // data = JSON.parse(data)
                if (msg.respCode == 0) {
                    var data = msg.respMsg.config;
                    (async () => {
                        if (/MicroMessenger/i.test(navigator.userAgent)) {
                            await new Promise((resolve, reject) => {
                                window.wx.config({
                                    beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
                                    debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                                    appId: corpid, // 必填，企业微信的corpID
                                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                                    signature: data.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
                                    jsApiList: ['selectExternalContact'], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
                                });
                                window.wx.ready(resolve)
                                window.wx.error(reject)
                            })
                        }
                        await new Promise((success, fail) => {
                            window.wx.agentConfig({
                                corpid: corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
                                agentid: Number(data.agentid), // 必填，企业微信的应用id （e.g. 1000247）
                                timestamp: data.timestamp, // 必填，生成签名的时间戳
                                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                                signature: data.signature,// 必填，签名，见附录-JS-SDK使用权限签名算法
                                jsApiList: ['selectExternalContact'], //必填
                                success: function (res) {
                                },
                                fail: function (res) {
                                    if (res.errMsg.indexOf('function not exist') > -1) {
                                        alert('版本过低请升级')
                                    }
                                }
                            });
                        })
                        // 注意: 只有 agentConfig 成功回调后，WWOpenData 才会注入到 window 对象上面

                    })()

                }
            })
            .catch((error) => {
                console.log(error)
            })
    }


    static dayOffToNow(expireAt) {
        let offset = expireAt - new Date().getTime();
        let fdays = offset * 1 / (24 * 60 * 60 * 1000);
        let days = Math.ceil(fdays);
        return days;
    }

    static msgSelectType() {
        return {
            SubsVal: "1",
            TASKPOSTER: "2"
        }
    }

    static uploadImage(files, size, success) {
        if (files.length === 0) {
            return;
        }
        let fileType = files[0].type.toLocaleLowerCase();
        if (!(fileType == 'image/png' || fileType == 'image/jpe' || fileType == 'image/jpeg')) {
            //不是图片文件
            Message.info('图片格式应为PNG/JPG/JPEG');
            return;
        }
        if (files[0].size > size) {
            //文件大小超过限制
            Message.info('图片大小超过' + (size / 1024) + 'KB');
            return;
        }

        let file = files[0];
        // console.log(file,'4444444444')
        let fetchUtil = new FetchUtil();
        fetchUtil.init()
            .setUrl(URL_DISTRI_GOODS_UPLOAD)
            .setMethod('POST')
            .setCookieCors()
            .setBodyType('file')
            .setBody({
                uploadfile: file
            })
            .dofetch()
            .then((msg) => {
                if (msg.respCode == 0) {
                    if (success) {
                        success(msg);
                    }
                } else {
                    Message.info("上传图片失败，请稍后再试")
                }
            })
            .catch(() => {
                Message.error("上传图片失败，请稍后再试")
            });
    }

    static zkCloudUpload(files, size, success, outSize, error) {
        if (files.length === 0) {
            return;
        }
        if (size && files[0].size > size) {
            //文件大小超过限制
            if (outSize) {
                outSize();
            }
            return;
        }
        let file = files[0];
        let fetchUtil = new FetchUtil();
        fetchUtil.init()
            .setUrl(ZKY_URL_DISTRI_GOODS_UPLOAD)
            .setMethod('POST')
            .setCookieCors()
            .setBodyType('file')
            .setBody({
                uploadfile: file
            })
            .dofetch()
            .then((msg) => {
                if (msg.respCode == 0) {
                    if (success) {
                        success(msg);
                    }
                } else if (error) {
                    error()
                }
            })
            .catch(() => {
                error()
            });
    }

    /*
    * 动态导出
    * */
    static downLoadFile(url) {
        const ele = document.createElement('a');
        ele.setAttribute('href', url); //设置下载文件的url地址
        ele.click();
    }

    /*
  * input数字保留小数
  * @params
  * step：0:整数，2:两位小数
  * */
    static getStepNumber(value, step) {
        if (step == 0) {
            value = parseInt(value);
        }
        if (step == 1) {
            const reg = /^(\-)*(\d+)(\.(\d){0,1}).*$/;
            value = value.replace(reg, '$1$2$3');
        }
        if (step == 2) {
            const reg = /^(\-)*(\d+)(\.(\d){0,2}).*$/;
            value = value.replace(reg, '$1$2$3');
        }

        if (isNaN(value) || value < 0) {
            value = '';
        }
        if (!Util.isEmpty(value)) {
            value = Number(value)
        }
        return value;
    }

    // 元，换算成分
    static centTransformIn(num) {
        num = parseFloat(num) * 100;
        let price = 0;
        if (isNaN(num) || num < 0) {
            price = 0.00;
        } else {
            price = num;
        }
        return price;
    }

    // 解决js数字小数点丢失精度的问题
    static numMulti(num1, num2) {
        let baseNum = 0;
        try {
            baseNum += num1.toString().split(".")[1].length;
        } catch (e) {
        }
        try {
            baseNum += num2.toString().split(".")[1].length;
        } catch (e) {
        }
        return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
    }

    //新的
    static checkPhoneNo(phoneNo) {
        let phoneNoReg = /^1[3456789]\d{9}$/;
        if (!phoneNoReg.test(phoneNo)) {
            return false;
        }
        return true;
    }

    //新加的手机号或者账号的判断
    static newLoginAccount(phoneNo) {
        let phoneNoReg = /^1[3456789]\d{9}$/; // 18295954430
        let newAccountReg = /^[_A-Za-z0-9]{1,16}@1[3456789]\d{9}$/; // asd51df@18295954430
        if (phoneNoReg.test(phoneNo) || newAccountReg.test(phoneNo)) {
            return true;
        }
        return false;
    }

    //新加的手机号或者账号的判断
    static newSubAccount(phoneNo) {
        let newAccountReg = /^[_A-Za-z0-9]{1,16}@1[3456789]\d{9}$/; // asd51df@18295954430
        if (newAccountReg.test(phoneNo)) {
            return true;
        }
        return false;
    }

    static checkPassword(pwd) {
        let pwdReg = /^(?![^a-zA-Z]+$)(?!\D+$).{6,16}$/;
        if (!pwdReg.test(pwd)) {
            return false;
        }
        return true;
    }

    static hashPwd(pwd) {
        pwd = md5(pwd + 'Hq44cyp4mT9Fh5eNrZ67bjifidFhW%fb0ICjx#6gE59@P@Hr8%!WuYBa1yvytq$qh1FEM18qA8Hp9m3VLux9luIYpeYzA2l2W3Z');
        return pwd;
    }

    //获取路径上的参数
    static getUrlArg(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");

        let r = window.location.search.substr(1).match(reg);

        if (r != null) return decodeURIComponent(r[2]);
        return null;
    }

    static getActivityId() {
        let activityId = Util.getUrlArg('activityId');
        if (!activityId) {
            activityId = 0;
        }
        return Number(activityId);
    }

    static initCopy(dquery, successText, errorText) {
        let clipboard = new ClipboardJS(dquery);
        clipboard.on('success', function (e) {
            Message.success(successText);
            e.clearSelection();
        });
        clipboard.on('error', function (e) {
            alert(errorText)
        });
    }

    //数字 转  汉字
    static toChinesNum(num) {
        let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
        let unit = ["", "十", "百", "千", "万"];
        num = parseInt(num);
        let getWan = (temp) => {
            let strArr = temp.toString().split("").reverse();
            let newNum = "";
            for (var i = 0; i < strArr.length; i++) {
                newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
            }
            return newNum;
        }
        let overWan = Math.floor(num / 10000);
        let noWan = num % 10000;
        if (noWan.toString().length < 4) {
            noWan = "0" + noWan;
        }
        return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    }

    /**
     * 设置默认的content没有20px的padding
     */
    static setContentStyle(style) {
        if (style) {
            let content = document.querySelector('.qy-content');
            for (let key in style) {
                content.style[key] = style[key];
            }
        }
    }

    static clearContent() {
        let content = document.querySelector('.qy-content');
        content.classList.add('qy-content-clear')
    }

    static resetContent() {
        let content = document.querySelector('.qy-content');
        content.classList.remove('qy-content-clear')
    }

    /**
     * 检测分销价格是否合法
     * @param price
     * @param returnType
     * @param royalty
     */
    static checkDistriPrice(price, returnType, royalty) {
        let rp = 0;
        if (returnType == 1) {
            if (royalty / 100 > Util.DistriMaxRate()) {
                Message.error("分销佣金不能大于商品价格的" + Util.DistriMaxRate() + "%", null, null, true);
            }
            rp = price * royalty / 100;
            if (rp < Util.DistriMinPrice()) {
                Message.error("分销佣金不能低于" + Util.centTransformOut(Util.DistriMinPrice()) + "元", null, null, true)
            }
        } else {
            if (royalty < Util.DistriMinPrice()) {
                Message.error("分销佣金不能低于" + Util.centTransformOut(Util.DistriMinPrice()) + "元", null, null, true)
            }
            rp = price * Util.DistriMaxRate();
            if (royalty > rp) {
                Message.error("分销佣金不能大于商品价格的" + Util.DistriMaxRate() + "%", null, null, true);
            }
        }
    }

    /**
     * 反转数组
     * @param arr
     */
    static reverseArr(arr) {
        let temp = [];
        if (arr) {
            for (let i = 0; i < arr.length; i++) {
                temp.unshift(arr[i])
            }
        }
        return temp;
    }

    // 文字折行
    static textFoldingLine(content) {
        return <Popover placement="top"
                        content={<span>{content}</span>}>
            {content && content.length > 9 ?
                <span>{content.substr(0, 9) + "..."}</span> :
                <span>{content}</span>
            }
        </Popover>
    }

    //在线聊天的名称展示   count名称 num 显示几个字符
    static chatNameHide(content, num) {
        return <>
            {content && content.length > num ?
                <span>{content.substr(0, num) + "..."}</span> :
                <span>{content}</span>
            }
        </>
    }

    static changeFavicon(link) {
        let $favicon = document.querySelector('link[rel="icon"]');
        if ($favicon !== null) {
            $favicon.href = link;
        } else {
            $favicon = document.createElement("link");
            $favicon.rel = "icon";
            $favicon.href = link;
            document.head.appendChild($favicon);
        }
    };

    //拼接路径 apiUrl路由 '/im/chat'  data数据 {id:1}
    static stitchingPath(apiUrl, data) {
        let reUrl = apiUrl + "?";
        if (data) {
            for (var name in data) {
                let item = name + "=" + data[name]
                reUrl = reUrl + item + "&";
            }
        }
        return reUrl.slice(0, reUrl.length - 1)
    }

    //在线聊天展示聊天的信息
    static displayingChatMessages(item) {
        if (item.msgType == 2 || item.msgType == 0) {
            return <>{item.msgSimpleData}</>
        } else if (item.msgType == 6) {
            return <>[位置]</>
        } else if (item.msgType == 14 || item.msgType == 101) {
            return <>[图片]</>
        } else if (item.msgType == 23 || item.msgType == 103) {
            return <>[视频]</>
        } else if (item.msgType == 15 || item.msgType == 102) {
            return <>[文件]</>
        } else if (item.msgType == 13) {
            return <>[链接]</>
        } else if (item.msgType == 41) {
            return <>[名片]</>
        } else if (item.msgType == 26) {
            return <>[红包]</>
        } else if (item.msgType == 29) {
            return <>[表情]</>
        } else if (item.msgType == 16) {
            return <>[语音]</>
        } else if (item.msgType == 78) {
            return <>[小程序]</>
        } else if (item.msgType == 141) {
            return <>[视频号]</>
        } else if (item.msgType == 1029) {
            return <>[系统消息]</>
        } else if (item.msgType == 10001) {
            return <>{item.senderName}撤回了一条消息</>
        } else if (item.msgType == 4) {
            return <>[聊天记录]</>
        } else if (item.msgType == 150024) {
            return <>{item.senderName}开启了联系人验证，你还不是他（她）的联系人。请先发送联系人验证请求，对方验证通过后，才能聊天。</>
        }
    }

    //在线聊天显示聊天的时间
    static showTimer(timer) {

        //获取当天是时间
        let time = (new Date(new Date().setHours(0, 0, 0, 0)).getTime()) / 1000;
        return <>
            {
                timer > time ? new Date(timer * 1000).format('hh:mm') : new Date(timer * 1000).format('MM-dd')
            }
        </>
    }

    //文件大小转string
    static fileSizeToString(limit) {
        let size = "";
        if (limit < 1 * 1024) { //如果小于1KB转化成B
            size = limit.toFixed(2) + "B";
        } else if (limit < 1 * 1024 * 1024) {//如果小于1MB转化成KB
            size = (limit / 1024).toFixed(2) + "K";
        } else if (limit < 1 * 1024 * 1024 * 1024) { //如果小于1GB转化成MB
            size = (limit / (1024 * 1024)).toFixed(2) + "MB";
        } else { //其他转化成GB
            size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "G";
        }

        var sizestr = size + "";
        var len = sizestr.indexOf("\.");
        var dec = sizestr.substr(len + 1, 2);
        if (dec == "00") {//当小数点后为00时 去掉小数部分
            return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
        }
        return sizestr;
    }

    //判断验证信息最大长度    50
    static checkFriendVerifyLen(verifyInfo) {
        //remark 内容
        //maxLen 限制长度
        let maxLen = 50
        if (verifyInfo.indexOf("#WXW_ACCOUNT_NAME#") != -1) {
            //判断有变量账号姓名
            maxLen = maxLen - 8
            verifyInfo = verifyInfo.replace(new RegExp('#WXW_ACCOUNT_NAME#', 'g'), "")
        }
        if (verifyInfo.length > maxLen) {
            return false;
        }
        return true;
    }

    //判断备注最大长度 20
    static checkRemarkLen(remark) {
        let maxLen = 20
        if (remark.indexOf("#NICKNAME#") != -1) {
            //判断有变量昵称
            maxLen = maxLen - 8
            remark = remark.replace(new RegExp('#NICKNAME#', 'g'), "")
        }
        if (remark.indexOf("#GENDER#") != -1) {
            //判断有变量性别
            maxLen = maxLen - 2
            remark = remark.replace(new RegExp('#GENDER#', 'g'), "")
        }
        if (remark.length > maxLen) {
            return false;
        }
        return true;
    }

    //判断描述信息最大长度 150
    static checkDescLen(desc) {
        let maxLen = 150
        if (desc.indexOf("#NICKNAME#") != -1) {
            //判断有变量昵称
            maxLen = maxLen - 8
            desc = desc.replace(new RegExp('#NICKNAME#', 'g'), "")
        }
        if (desc.indexOf("#ADD_TIME#") != -1) {
            //判断有变量时间
            maxLen = maxLen - 19
            desc = desc.replace(new RegExp('#ADD_TIME#', 'g'), "")
        }
        if (desc.indexOf("#GENDER#") != -1) {
            //判断有变量性别
            maxLen = maxLen - 2
            desc = desc.replace(new RegExp('#GENDER#', 'g'), "")
        }
        if (desc.length > maxLen) {
            return false;
        }
        return true;
    }

    //实现模糊搜索的关键字高亮
    //value 查找的那段文字   keyWord关键词
    //调用 <span dangerouslySetInnerHTML={{__html: Util.textHightLight('王麻子', '王')}}></span>
    static textHightLight(value, keyWord) {
        if (value.indexOf(keyWord) !== -1 && keyWord !== '') {
            return value.replace(keyWord, `<font color="#1673FF">${keyWord}</font>`)
        }
        return value
    }

    //时间戳加随机数
    static randomString(len) {
        len = len || 10;
        let timestamp = new Date().getTime();
        /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
        let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        let maxPos = $chars.length;
        let randomStr = '';
        for (let i = 0; i < len; i++) {
            randomStr += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        // console.log('时间戳', timestamp)
        // console.log('随机数', randomStr)
        return randomStr + timestamp;
    }

    // 判断企微助手是否有权限   接受三个参数
    // configuration        配置表
    // hostKey              主key值
    // sonKey               子key值
    //wxworkHelper
    static wxWorkHelperJurisdiction(configuration, hostKey, sonKey) {
        if (JSON.stringify(configuration) != '{}' && configuration != undefined) {
            if (configuration.wxworkHelper && configuration.wxworkHelper != undefined) {
                for (let i in configuration.wxworkHelper) {
                    for (let j in configuration.wxworkHelper[i].submenu) {
                        if (configuration.wxworkHelper[i].submenu[j].key == hostKey) {
                            if (configuration.wxworkHelper[i].submenu[j].checked) {
                                for (let k in configuration.wxworkHelper[i].submenu[j].submenu) {
                                    if (configuration.wxworkHelper[i].submenu[j].submenu[k].key == sonKey) {
                                        return configuration.wxworkHelper[i].submenu[j].submenu[k].checked
                                    }
                                }
                            } else {
                                return configuration.wxworkHelper[i].submenu[j].checked
                            }
                        }
                    }
                }
            }
        }
    }

    static wxWorkHelperProJurisdiction(configuration, hostKey, sonKey) {
        if (JSON.stringify(configuration) != '{}' && configuration != undefined) {
            if (configuration.wxworkHelperPro && configuration.wxworkHelperPro != undefined) {
                for (let i in configuration.wxworkHelperPro) {
                    for (let j in configuration.wxworkHelperPro[i].submenu) {
                        if (configuration.wxworkHelperPro[i].submenu[j].key == hostKey) {
                            if (configuration.wxworkHelperPro[i].submenu[j].checked) {
                                for (let k in configuration.wxworkHelperPro[i].submenu[j].submenu) {
                                    if (configuration.wxworkHelperPro[i].submenu[j].submenu[k].key == sonKey) {
                                        return configuration.wxworkHelperPro[i].submenu[j].submenu[k].checked
                                    }
                                }
                            } else {
                                return configuration.wxworkHelperPro[i].submenu[j].checked
                            }
                        }
                    }
                }
            }
        } else {
            return true
        }
    }

    //重新组装导航
    //接受俩个参数
    //array
    //type 区分  wxworkHelper企微助手  wxworkHelperPro企微助手Pro
    static newNavConfig(array, type) {
        let navList = []
        if (array.length > 0) {
            for (let i in array) {
                for (let j in array[i].submenu) {
                    let subNav = []
                    for (let k in array[i].submenu[j].submenu) {
                        subNav.push({
                            title: global[type][array[i].submenu[j].submenu[k].key].title,
                            path: global[type][array[i].submenu[j].submenu[k].key].path,
                            pathIn: global[type][array[i].submenu[j].submenu[k].key].pathIn,
                            checked: array[i].submenu[j].submenu[k].checked,
                            link: global[type][array[i].submenu[j].submenu[k].key] == 'account_chat' ? true : null
                        })
                    }
                    navList.push({
                        title: global[type][array[i].submenu[j].key].title,
                        key: array[i].submenu[j].key,
                        isOpen: 'true',
                        checked: array[i].submenu[j].checked,
                        icon: global[type][array[i].submenu[j].key].icon,
                        submenu: subNav
                    })
                }
            }
        }
        return navList
    }
}

export default Util